/**
 *
 * @module personalizationEvents
 * @see https://github.bamtech.co/sdk-doc/spec-sdk/blob/master/specs/feature_overviews/user-activity.md#known-events
 *
 */

import Services from './../../services/entry';

import PersonalizationEvent from './personalizationEvent';

const PersonalizationDustUrnReference = Services.Internal.Dust.DustUrnReference.userActivity.personalization;

/**
 *
 * @access public
 * @type {Object<String, SDK.UserActivity.PersonalizationEvent>})
 * @note the IIFE is required as the application developer will not be expecting to invoke this method
 *
 */
export default {
    contentRecommendationAward: (() => new PersonalizationEvent(
        PersonalizationDustUrnReference.contentRecommendationAward
    ))()
};



// WEBPACK FOOTER //
// ./src/userActivity/personalization/personalizationEvents.js